export const UPDATE_LOGO = 'UPDATE_LOGO';
export const UPDATE_THEME = 'UPDATE_THEME';
export const LOAD_THEME = 'LOAD_THEME';
